import { define } from 'wicked-elements'
import zeroFill from 'zero-fill'
import losAngelesTime from '../lib/losAngelesTime'

define('[data-component~="clock"]', {
  init () {
    this.interval = null
    this.update()
    this.render()
  },
  connected () {
    this.interval = setInterval(() => {
      this.update()
      this.render()
    }, 1000)
  },
  disconnected () {
    clearInterval(this.interval)
    this.interval = null 
  },
  update () {
    let date = losAngelesTime()
    this.hour = zeroFill(2, date.getHours())
    this.minute = zeroFill(2, date.getMinutes())
    this.second = zeroFill(2, date.getSeconds())
  },
  render () {
    this.element.innerHTML = `${this.hour}:${this.minute}:${this.second}`
  }
})